import React, { useState, useCallback } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { isBrowser } from '../utils/DeviceDetect';
import PropTypes from "prop-types";

const CustomTooltip = ({
    placement = 'top',
    hide = false,
    id,
    tooltip,
    theme,
    children,
    showDelay = 500,
    hideDelay = 500,
    containerClassName = '',
}) => {
    const [shouldUpdatePosition, setShouldUpdatePosition] = useState(false);

    const updatePosition = useCallback(() => {
        setShouldUpdatePosition(true);
    }, []);

    const getTheme = useCallback(() => {
        return theme ? `tooltip_${theme}` : '';
    }, [theme]);

    const getTooltip = useCallback(() => {
        if (React.isValidElement(tooltip)) {
            return React.cloneElement(
                tooltip,
                {
                    overlayID: id,
                    placement: placement,
                    updatePosition: updatePosition
                }
            );
        }

        return tooltip;
    }, [tooltip, id, placement, updatePosition]);

    const renderOverlayTrigger = useCallback(() => {
        if (hide) {
            return '';
        }
        return (
            <OverlayTrigger
                overlay={<Tooltip id={id} style={{zIndex: 99999}} className={getTheme()}> {getTooltip()} </Tooltip>}
                placement={placement}
                delay={{ show: showDelay, hide: hideDelay }}
                shouldUpdatePosition={shouldUpdatePosition}
            >
                <div style={{ justifySelf: 'center' }} className={containerClassName}>{children}</div>
            </OverlayTrigger>
        );
    }, [hide, id, getTheme, getTooltip, placement, shouldUpdatePosition, children, showDelay, hideDelay]);

    if (hide) {
        return '';
    }
    return renderOverlayTrigger()
};

CustomTooltip.propTypes = {
    placement: PropTypes.string,
    hide: PropTypes.bool,
    id: PropTypes.string,
    tooltip: PropTypes.string,
    theme: PropTypes.string,
    children: PropTypes.node
};

export default CustomTooltip;
